import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  errorMessage,
  employerTagsKey,
  createEmployerTagsRoute,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';

type useEmployerCreatetagsProps = {
  setErrorText?: Dispatch<SetStateAction<string>>;
};

export const useEmployerCreatetags = ({
  setErrorText = () => { },
}: useEmployerCreatetagsProps) => {
  const client = useQueryClient();

  const { mutate: createEmployerTags, isLoading: isCreateEmployerTagsLoading } =
    useMutation({
      mutationFn: (variables: {
        tag: string;
      }) =>
        axiosInstance
          .post(createEmployerTagsRoute, variables, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status !== 200) {
          setErrorText(data.message);
        } else {
          setErrorText('');
          client.invalidateQueries([employerTagsKey]);
        }
      },
      onError: () => {
        setErrorText(errorMessage);
      },
    });

  return {
    createEmployerTags,
    isCreateEmployerTagsLoading,
  };
};
